import Vue from 'vue'

Vue.mixin({
    methods:{
        validator(state) {
            for (const key in this.form) {
                this.form[key].inv = '';
            }
            this.disable = false;
            for (const key in this.form) {
                if(state == 1){
                    if(key == 'verification_code'){
                        continue;
                    }
                } else if(state == 2){
                    if(key == 'verification_code'
                        || key == 'password'
                        || key == 'repeat_password'){
                            continue;
                        }
                }
                for (const k in this.form[key].v) {
                    switch (k) {
                        case 'req':
                            if (this.form[key].val == '') {
                                this.form[key].inv = 'پر کردن این فیلد اجباری است.';
                                this.disable = true;
                            }
                            break;
                        case 'min':
                            if (this.form[key].val != '') {
                                if (this.form[key].val.length < this.form[key].v[k]) {
                                    this.form[key].inv = `باید حداقل ${this.form[key].v[k]} کاراکتر باشد.`
                                    this.disable = true;
                                }
                            }
                            break;
                        case 'max':
                            if (this.form[key].val != '') {
                                if (this.form[key].val.length > this.form[key].v[k]) {
                                    this.form[key].inv = `باید حداکثر ${this.form[key].v[k]} کاراکتر باشد.`
                                    this.disable = true;
                                }
                            }
                            break;
                        case 'spec':
                            switch (this.form[key].v[k]) {
                                case 'ip':
                                    if (this.form[key].val != '' && this.form[key].inv == '') {
                                        const re_url = new RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/);
                                        if (!re_url.test(String(this.form[key].val))) {
                                            this.form[key].inv = 'IP معتبر نیست.';
                                            this.disable = true;
                                        }
                                    }
                                    break;
                                case 'mobile':
                                    if(this.form[key].val != '' && this.form[key].inv == ''){
                                        const re_mobile = new RegExp(/^(0)?9\d{9}$/);
                                        if (!re_mobile.test(String(this.form[key].val).toLowerCase())) {
                                            this.form[key].inv = 'شماره موبایل معتبر نیست.';
                                            this.disable = true;
                                        }
                                    }
                                    break;
                                case 'password':
                                    if(this.form[key].val != '' && this.form[key].inv == ''){
                                        const re_password = new RegExp(/^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})/);
                                        if (!re_password.test(String(this.form[key].val))) {
                                            this.form[key].inv = 'باید حداقل ۸ کاراکتر و شامل عدد، کاراکتر بزرگ و کوچک باشد.';
                                            this.disable = true;
                                        }
                                    }
                                    break;
                                case 'repeat_password':
                                    if(this.form[key].val != '' && this.form[key].inv == ''){
                                        if(this.form[key].val != this.form.password.val){
                                            this.form[key].inv = 'مقدار رمز عبور و تکرار رمز عبور یکسان نیست.';
                                            this.disable = true;
                                        }
                                    }
                                    break;
                                case 'mobile_number':
                                    if (this.form[key].val != '' && this.form[key].inv == '') {
                                        const re_mobile_number = new RegExp(/^(98)?9\d{11}$/);
                                        if (!re_mobile_number.test(String(this.form[key].val))) {
                                            this.form[key].inv = 'شماره معتبر نیست.';
                                            this.disable = true;
                                        }
                                    }
                                    break;
                                case 'url':
                                    if (this.form[key].val != '' && this.form[key].inv == '') {
                                        const re_url = new RegExp(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/);
                                        if (!re_url.test(String(this.form[key].val).toLowerCase())) {
                                            this.form[key].inv = 'لینک معتبر نیست.';
                                            this.disable = true;
                                        }
                                    }
                                    break;
                                case 'email':
                                    if (this.form[key].val != '' && this.form[key].inv == '') {
                                        const re_email = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                                        if (!re_email.test(String(this.form[key].val).toLowerCase())) {
                                            this.form[key].inv = 'ایمیل معتبر نیست.';
                                            this.disable = true;
                                        }
                                    }
                                    break;
                            }
                            break;
                    }
                }
            }
        },
    }
});